import { api } from './_apiInterface';
import { pointer } from 'src/app-config';
import * as types from '@monorepo/models';

class HouseToHouseServices {
    private Base = pointer.houseToHouse;
    //
    AddDoNotCall = async (territory: types.typeTerritoryNumber, block: types.typeBlock, face: types.typeFace, polygonId: number, doNotCall: types.typeDoNotCall) => {
        if (!territory || !block || !face || !polygonId || !doNotCall) {
            throw new Error("Faltan datos");
        }
        const data = await api.SendRequest(`${this.Base}/do-not-call/${territory}/${block}/${face}`, 'POST', { doNotCall, polygonId });
        return data;
    }    
    AddObservation = async (territoryNumber: types.typeTerritoryNumber, block: types.typeBlock, face:types.typeFace, polygonId: number, observation: types.typeObservation) => {
        if (!territoryNumber || !block || !face || !polygonId || !observation) {
            throw new Error("Faltan datos");
        }
        const data = await api.SendRequest(`${this.Base}/observation/${territoryNumber}/${block}/${face}`, 'POST', { observation, polygonId });
        return data;
    }
    AddPolygonFacesToTerritory = async (territoryNumber: types.typeTerritoryNumber, faces: types.typeHTHFace[]) => {
        if (!territoryNumber || !faces?.length) {
            throw new Error("Faltan datos");
        }
        const data = await api.SendRequest(`${this.Base}/map/${territoryNumber}`, 'POST', { faces });
        return data;
    }
    AssignTerritory = async (user: types.typeUser, toAssign: number | null, toUnassign: number | null, all: boolean | null) => {
        all = !!all;
        const data = await api.SendRequest(`${this.Base}/assignment`, 'PUT', { all, user, toAssign, toUnassign });
        return data;
    }
    CreateTerritories = async (numberOfTerritories: number, lat: number, lng: number) => {
        if (!numberOfTerritories || !lat || !lng) {
            throw new Error("Faltan datos");
        }
        const data = await api.SendRequest(`${this.Base}/genesys`, 'POST', { numberOfTerritories, lat, lng });
        return data;
    }
    DeletePolygonFace = async (territoryNumber: types.typeTerritoryNumber, block: types.typeBlock, face: types.typeFace, faceId: number) => {
        if (!territoryNumber || !block || !face || !faceId) {
            throw new Error("Faltan datos");
        }
        const data = await api.SendRequest(`${this.Base}/map/${territoryNumber}/${block}/${face}`, 'DELETE', { faceId });
        return data;
    }
    DeleteDoNotCall = async (territoryNumber: types.typeTerritoryNumber, block: types.typeBlock, face: types.typeFace, doNotCallId: number) => {
        if (!territoryNumber || !block || !face || !doNotCallId) {
            throw new Error("Faltan datos");
        }
        const data = await api.SendRequest(`${this.Base}/do-not-call/${territoryNumber}/${block}/${face}`, 'DELETE', { doNotCallId });
        return data;
    }
    DeleteObservation = async (territoryNumber: types.typeTerritoryNumber, block: types.typeBlock, face:types.typeFace, observationId: number) => {
        if (!territoryNumber || !block || !face || !observationId) {
            throw new Error("Faltan datos");
        }
        const data = await api.SendRequest(`${this.Base}/observation/${territoryNumber}/${block}/${face}`, 'DELETE', { observationId });
        return data;
    }
    EditObservation = async (territoryNumber: types.typeTerritoryNumber, block: types.typeBlock, face:types.typeFace, observation: types.typeObservation) => {
        if (!territoryNumber || !block || !face || !observation) {
            throw new Error("Faltan datos");
        }
        const data = await api.SendRequest(`${this.Base}/observation/${territoryNumber}/${block}/${face}`, 'PATCH', { observation });
        return data;
    }
    EditMap = async (territoryNumber: types.typeTerritoryNumber, centerCoords: types.typeCoords, zoom: number, editedHTHPolygons: types.typeHTHFace[]) => {
        const data = await api.SendRequest(`${this.Base}/map/${territoryNumber}`, 'PATCH', { centerCoords, editedHTHPolygons, zoom });
        return data;
    }
    GetBuilding = async (congregation: number, territoryNumber: string, block: types.typeBlock, face: types.typeFace, streetNumber: number) => {
        // no token
        const data = await api.SendRequest<{ config: types.typeConfigDoc, hthTerritory: types.typeHTHTerritory; }>(`${this.Base}/building/${congregation}/${territoryNumber}/${block}/${face}/${streetNumber}`, 'GET');
        return data;
    }
    GetNumbersOfReleasedTerritories = async (congregation: number) => {
        // no token
        const data = await api.SendRequest<{ numbersOfTerritories: number[]; }>(`${this.Base}/released?congregation=${congregation}`, 'GET');
        return data;
    }
    GetFaceFromAddress = async (address: string) => {
        if (!address) {
            throw new Error("Faltan datos");
        }
        const data = await api.SendRequest<{ hthFace: types.typeHTHFace; streetNumber?: number; }>(`${this.Base}/face?address=${encodeURIComponent(address)}`, 'GET');
        return data;
    }
    GetStreetsByTerritory = async (territoryNumber: types.typeTerritoryNumber) => {
        if (!territoryNumber) {
            throw new Error("Faltan datos");
        }
        const data = await api.SendRequest<{ streets: string[]; }>(`${this.Base}/street/${territoryNumber}`, 'GET');
        return data;
    }
    GetTerritoriesForStatistics = async () => {
        const data = await api.SendRequest<{ hthTerritories: types.typeHTHTerritory[]; }>(`${this.Base}/map/territory-statistics`, 'GET');
        return data;
    }
    GetTerritoriesForMap = async () => {
        const data = await api.SendRequest<{ hthTerritories: types.typeHTHTerritory[]; }>(`${this.Base}/map/territory-map`, 'GET');
        return data;
    }
    GetTerritoriesFromServiceUnauth = async (congregation: number, serviceId: number) => {
        const data = await api.SendRequest<{ config: types.typeConfigDoc; hthTerritories: types.typeHTHTerritory[]; }>(`${this.Base}/map/territory-map?congregation=${congregation}&serviceId=${serviceId}`, 'GET');
        return data;
    }
    GetTerritory = async (territoryNumber: string, congregation: number | null = null, block?: types.typeBlock | null) => {
        // no token
        if (!territoryNumber) {
            throw new Error("Faltan datos");
        }
        const data = await api.SendRequest<{ config: types.typeConfigDoc; hthTerritory: types.typeHTHTerritory; }>(`${this.Base}/${territoryNumber}${congregation ? `?congregation=${congregation}&block=${block ?? ''}` : ''}`, 'GET');
        return data;
    }
    RestructuringTerritories = async (newHthTerritories: types.typeHTHTerritory[]) => {
        const data = await api.SendRequest(`${this.Base}/restructuring`, 'PUT', { newHthTerritories });
        return data;
    }
    SetActivity = async (hthTerritories: types.typeHTHTerritory[], month: number, year: number) => {
        const data = await api.SendRequest(`${this.Base}/activity`, 'POST', { month, hthTerritories, year });
        return data;
    }
    SetActivityFeedback = async (congregation: number, datetime: number, hthTerritories: types.typeHTHTerritory[], serviceId: number, isLogging = false) => {
        const data = await api.SendRequest(`${this.Base}/feedback`, 'POST', { congregation, datetime, hthTerritories, isLogging, serviceId });
        return data;
    }
    //////// BUILDINGS
    AddBuilding = async (territoryNumber: types.typeTerritoryNumber, block: types.typeBlock, face: types.typeFace, newBuilding: types.typeHTHBuilding) => {
        const data = await api.SendRequest(`${this.Base}/building/${territoryNumber}/${block}/${face}`, 'POST', { newBuilding });
        return data;
    }
    ChangeStateToHousehold = async (congregation: number, territoryNumber: types.typeTerritoryNumber, block: types.typeBlock, face: types.typeFace, streetNumber: number, buildingId: number, householdId: number, street: string, callingState: number, isSwitchingAmongNoZeroStates: boolean) => {
        // no token
        const body = {
            buildingId,
            callingState,
            householdId,
            isSwitchingAmongNoZeroStates,
            street,
            streetNumber
        };
        const data = await api.SendRequest(`${this.Base}/building/${congregation}/${territoryNumber}/${block}/${face}`, 'PATCH', body);
        return data;
    }
    DeleteBuilding = async (territoryNumber: types.typeTerritoryNumber, block: types.typeBlock, face: types.typeFace, streetNumber: number) => {
        const data = await api.SendRequest(`${this.Base}/building/${territoryNumber}/${block}/${face}`, 'DELETE', { streetNumber });
        return data;
    }
    EditBuildingAddress = async (currentBuildingAddress: types.typeAddress, newBuildingAddress: types.typeAddress) => {
        if (!currentBuildingAddress || !newBuildingAddress) {
            throw new Error("Faltan datos");
        }
        const data = await api.SendRequest(`${this.Base}/building-address`, 'PATCH', { currentBuildingAddress, newBuildingAddress });
        return data;
    }
    ResetHouseholdsAll = async () => {
        const data = await api.SendRequest(`${this.Base}/reset`, 'PATCH', { all: true });
        return data;
    }
    ResetHouseholdsFromBuilding = async (building: types.typeHTHBuilding) => {
        const data = await api.SendRequest(`${this.Base}/reset`, 'PATCH', { building });
        return data;
    }
    ResetHouseholdsFromTerritory = async (territoryNumber: types.typeTerritoryNumber) => {
        const data = await api.SendRequest(`${this.Base}/reset`, 'PATCH', { territoryNumber });
        return data;
    }
    // SelectByVoice = async (audioBlob: Blob, congregation: number, territoryNumber?: types.typeTerritoryNumber, householdId?: number) => {
    //     // no token
    //     const body = {
    //         audioBase64: await blobToBase64(audioBlob),
    //         congregation,
    //         householdId,
    //         mimeType: audioBlob.type,
    //         territoryNumber
    //     };
    //     const data = await api.SendRequest(`${this.Base}/building-voice`, 'PATCH', body, false);
    //     return data;
    // }
    SetIsSharedBuildings = async (territoryNumber: types.typeTerritoryNumber, block?: types.typeBlock, face?: types.typeFace, streetNumbers?: number[]) => {
        const data = await api.SendRequest(`${this.Base}/building/${territoryNumber}?block=${block ? block : ''}&face=${face ? face : ''}`, 'PUT', { streetNumbers });
        return data;
    }
    ShareBuildingForAMonth = async (territoryNumber: types.typeTerritoryNumber, block: types.typeBlock, face: types.typeFace, streetNumber: number) => {
        const data = await api.SendRequest(`${this.Base}/building/${territoryNumber}?block=${block}&face=${face}&streetNumber=${streetNumber}`, 'PATCH');
        return data;
    }
}

export const houseToHouseServices = new HouseToHouseServices();
